export const fetchTemplate = `query fetchTemplate($kmatID: String!) {
    fetchTemplate(kmatID: $kmatID)
  }`;
  